import { ValidationProvider, extend, setInteractionMode } from "vee-validate";
import { required, email, min } from "vee-validate/dist/rules";

const eager = ({ errors }) => {
  if (errors.length) {
    return {
      on: ["input", "change"],
    };
  }

  return {
    on: ["blur"],
  };
};

setInteractionMode(eager);

extend("required", {
  ...required,
  message: "This field is required",
});

extend("email", {
  ...email,
  message: "This is not a valid email",
});

extend("min", {
  ...min,
  message: "Six characters are required",
});

extend("password", {
  validate: (value, { other }) => value === other,
  message: "The password confirmation does not match.",
  params: [{ name: "other", isTarget: true }],
});

// Register it globally
export default ValidationProvider;
